<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>文件列表</h3></div>
    <el-form
      :inline="!UI.isMobile"
      :label-position="UI.isMobile ? 'top' : 'right'"
      size="mini"
      :model="filterForm"
    >
      <el-form-item label="标题">
        <el-input
          clearable
          v-model="filterForm.title"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="描述">
        <el-input
          clearable
          v-model="filterForm.desc"
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            flushData();
          "
        >
          查询
        </el-button>
        <el-button
          @click="
            filterForm = { page: 1, page_size: 10 };
            flushData();
          "
        >
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="desc" label="描述"></el-table-column>
      <el-table-column label="下载地址">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{ scope.row.url }}</a>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="180">
        <template slot="header" slot-scope="scope">
          <el-button
            @click="
              fileInfo = {};
              isShow = true;
            "
            type="primary"
            size="small"
          >
            发布文件
          </el-button>
        </template>
        <template slot-scope="scope">
          <el-button
            @click="deleteFile(scope.row.id)"
            type="danger"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="发布文件"
      :visible.sync="isShow"
      width="800px"
      show-close
      :fullscreen="UI.isMobile"
    >
      <div class="flex flex-direction align-center">
        <el-form
          ref="fileInfoForm"
          :model="fileInfo"
          :rules="fileInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'"
          :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;"
        >
          <el-form-item label="文件标题" prop="title">
            <el-input
              placeholder="请输入标题"
              clearable
              v-model="fileInfo.title"
            ></el-input>
          </el-form-item>

          <el-form-item label="文件描述" prop="desc">
            <el-input
              placeholder="请输入描述"
              clearable
              v-model="fileInfo.desc"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传文件" prop="url">
            <MediaUpload
              ref="url"
              :action="uploadUrl + '/upload/download'"
              :suffixList="[]"
              :file="fileInfo.url"
              @success="handlerUploadSuccess('url')"
            ></MediaUpload>
          </el-form-item>

          <el-form-item label="文件时间" prop="c_time">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="fileInfo.c_time"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>

        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="submit()"
        >
          提交审核
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getFilesList,
  addUploadFile,
  deleteUploadFile,
} from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import MediaUpload from '@/components/upload/mediaUpload.vue';
import { baseUrl } from '@/utils/consts.js';

export default {
  components: {
    MediaUpload,
  },

  data() {
    return {
      uploadUrl: baseUrl,
      fileInfo: {},
      isShow: false,
      filterForm: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      tableData: [],
      fileInfoRules: {
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        desc: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'blur',
          },
        ],
        url: [
          {
            required: true,
            message: '请上传文件',
            trigger: 'blur',
          },
        ],
        c_time: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      this.page = 1;
      getFilesList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handlerUploadSuccess: function(key) {
      this.fileInfo[key] = this.$refs[key].uploadRes;
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    deleteFile: function(fileId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deleteUploadFile(fileId, function(res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    submit: function() {
      let that = this;
      this.$refs.fileInfoForm.validate((valid) => {
        if (valid) {
          addUploadFile(this.fileInfo, function(res) {
            that.fileInfo = {};
            that.isShow = false;
            that.flushData();
            showSuccessMsg(res);
          });
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/fileManager/index.vue